import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CatalogService } from '../../../../providers/services/catalog.service';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from '../../../../providers/services/utils.service';
import { DOCUMENT } from '@angular/common';
import { BaseFragmentComponent } from '../../../base-fragment.component';

@Component({
  selector: 'app-product-footer',
  templateUrl: './product-footer.component.html',
  styleUrls: ['./product-footer.component.scss']
})
export class ProductFooterComponent extends BaseFragmentComponent implements OnInit, OnDestroy {
  private readonly ALL_MACHINES_SLUG = '';
  private readonly ALL_CATEGORIES_SLUG = '';

  @Input() hasFilters = true;

  @Input() set startWithFilter(value) {
    this.currentMachine = value;
    this.hideFilterControl = true;
  }

  @Input() kit;
  @Input() firstBannerData;
  @Input() secondaryBannerData;
  private readonly subscriptions: Subscription = new Subscription();

  public readonly config: SwiperConfigInterface = {
    autoplay: false,
    loop: false,
    freeMode: false,
    spaceBetween: 0,
    breakpointsInverse: true,
    navigation: false,
    mousewheel: false,
    slidesPerView: 1
  };

  formGroup: FormGroup;
  hideFilterControl = false;
  accessoriesWithCategories;
  accessoriesToShow;
  machineFilters;
  categoryFilters;

  private currentMachine = this.ALL_MACHINES_SLUG;
  private currentCategory = this.ALL_CATEGORIES_SLUG;

  constructor(
    private catalogService: CatalogService, private formBuilder: FormBuilder, activatedRoute: ActivatedRoute,
    utilsService: UtilsService, @Inject(DOCUMENT) document
  ) {
    super(activatedRoute, utilsService, document);
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      category_slug: this.ALL_CATEGORIES_SLUG,
      machine_slug: this.ALL_MACHINES_SLUG
    });

    this.subscriptions.add(this.catalogService.getAccessoriesCategories(this.currentMachine).subscribe(({ body }) => {
      this.handleGetAccessoriesCategoriesResult(body);
      this.initScrollBehavior();
    }));
  }

  private filterAccessoriesToShowByCategory(selectedCategory) {
    if (this.accessoriesWithCategories && this.accessoriesWithCategories.length !== 0) {
      const accessories = [];
      const categoriesToFilter = selectedCategory === this.ALL_CATEGORIES_SLUG ? this.accessoriesWithCategories
        : this.accessoriesWithCategories.filter(category => category.name === selectedCategory);

      categoriesToFilter.forEach(category => {
        category.accessories.forEach(accessory => {
          if (accessory.image_header) {
            accessories.push(accessory);
          }
        });
      });

      this.accessoriesToShow = accessories;
    }
  }

  private handleGetAccessoriesCategoriesResult(body, categoryToFilter?: string | undefined) {
    const apiResult = body ? body.data.accessories_categories : undefined;
    const selectedCategory = categoryToFilter !== this.ALL_CATEGORIES_SLUG ? categoryToFilter : undefined;

    if (apiResult) {
      const categories = [];
      const accessories = [];
      let categoriesWithAccessories = apiResult;

      if (selectedCategory) {
        categoriesWithAccessories = categoriesWithAccessories.filter(category => category.name === selectedCategory);
      }

      categoriesWithAccessories.forEach(categoryWithAccessories => {
        categories.push(categoryWithAccessories.name);
        categoryWithAccessories.accessories.forEach(accessory => {
          accessory.categoryId = '' + categoryWithAccessories.id;
          if (accessory.image_header) {
            accessories.push(accessory);
          }
        });
      });
      this.categoryFilters = categories;
      this.accessoriesToShow = accessories;
      this.accessoriesWithCategories = apiResult;
    }

    if (!this.machineFilters) {
      this.machineFilters = body ? body.meta.filters : undefined;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  searchAccessories() {
    const selectedMachine = this.formGroup.get('machine_slug').value;
    const selectedCategory = this.formGroup.get('category_slug').value;
    this.update(selectedMachine, selectedCategory);
  }

  private update(selectedMachine, selectedCategory) {
    if (selectedMachine === this.currentMachine) {
      this.currentCategory = selectedCategory;
      this.filterAccessoriesToShowByCategory(selectedCategory);
    } else {
      this.currentMachine = selectedMachine;
      this.currentCategory = selectedCategory;

      this.catalogService.getAccessoriesCategories(selectedMachine)
        .subscribe(({ body }) => {
          this.handleGetAccessoriesCategoriesResult(body, selectedCategory);
        });
    }
  }

  resetAccessories() {
    this.formGroup.get('machine_slug').setValue(this.ALL_MACHINES_SLUG);
    this.formGroup.get('category_slug').setValue(this.ALL_CATEGORIES_SLUG);
    this.update(this.ALL_MACHINES_SLUG, this.ALL_CATEGORIES_SLUG);
  }
}
